import {Graphics, InteractionEvent} from 'pixi.js';
import {DraggableObject} from '../../../../../base/DraggableObject';
import {IPoint} from '../../../../../interfaces/primitives/IPoint';
import PixiUtil from '../../../../../../api/render/pixi/PixiUtil';
import {DrawHolderEvent} from '../../events/DrawHolderEvent';

export class InstrumentSliderButton extends DraggableObject
{
    dragEndX: number = 80;
    private slider: Graphics;

    constructor() {
        super();

        this.slider = new Graphics();
        this.slider.beginFill(0xf65a00, 1);
        this.slider.drawRoundedRect(0, -20, 20, 40, 3);
        this.slider.endFill();
        this.addChild(this.slider);
    }

    /**
     * Ограничение перемещения внутри области перетаскивания
     * @param x - желаемая координата по горизонтали
     * @param y - желаемая координата по вертикали
     * @returns объект содержащий возможные координаты, полученные из желаемых
     */
    clampPos(x: number, y: number): IPoint {
        x = PixiUtil.clamp(0, x, this.dragEndX);
        return {x, y: 0};
    }

    /**
     * Обработчик события pointerup
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerUp(e: InteractionEvent): void {
        super.onPointerUp(e);
        this.dispatchSelectSizeEvent();
    }

    /**
     * Обработчик события pointerupoutside
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerUpOutside(e: InteractionEvent): void {
        super.onPointerUpOutside(e);
        this.dispatchSelectSizeEvent();
    }

    /**
     * Применяем позиционирование
     * @param position - объект содержащий координаты применяемой позиции по осям
     */
    moveTo(position: IPoint): void {
        super.moveTo(position);
        this.dispatchSelectSizeEvent();
    }

    private dispatchSelectSizeEvent() {
        dispatchEvent(new MessageEvent(DrawHolderEvent.SELECT_SIZE, {data: {size: this.x / this.dragEndX}}));
    }
}
